<template>
  <div class="baccarat game-table" :id="'bc-' + tableId">
    <div class="game-table-title">
      <div class="row">
        <div class="col-xs-7">
          <h4>
            <i class="fa fa fa-cubes"></i>
            <span class="kind">{{ header }}</span>
            <!-- <span class="label label-info game-kind">{{ title }}</span> -->
          </h4>
        </div>
        <div class="col-xs-5 game-info text-right">
          <span v-if="round > 0">
            {{ $t('messages.round') }} {{ gameInfo }}
          </span>
          <span v-else>{{ $t('messages.break') }}</span>
        </div>
      </div>
    </div>
    <div class="game-table-detail clearfix">
      <div class="game-table-preview dragscroll">
        <div class="game-table-panel" style="height:100%" :style="'min-width:' + autoWidth + 'px'">
          <div class="box-stat-wrapper" v-if="statistics['bigRoad'].length > 0">
            <div class="box-col" v-for="(col, c) in fixing.col" :key="'col-' + c">
              <span v-if="getPointer('bigRoad', r, c)" v-for="(row, r) in fixing.row" :key="'row-' + r">
                <i :class="renderShortHand('bigRoad', r, c).class" :data-marker="r + ':' + c"></i>
              </span>
              <span v-else :key="'row-' + r">
                <i class="empty"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- dealer image -->
      <div class="game-table-img">
        <span class="game-kind">{{ title }}</span>
        <img :src="image" width="100" height="100" key="image" v-if="image">
        <img src="//placehold.it/100x100" key="image" v-else>
      </div>
    </div>
    <div class="game-table-sub clearfix">
      <div class="row">
        <div class="col-lg-6 col-xs-5">
          <span>
            {{ $t('messages.bettime', { time: duration }) }}
          </span>
        </div>
        <div class="col-lg-6 col-xs-7 pull-right">
          <div class="box-winner">
            <div class="winner">
              <span>{{ winners.b }}</span>
              <i class="b"></i>
            </div>
            <div class="winner">
              <span>{{ winners.p }}</span>
              <i class="p"></i>
            </div>
            <div class="winner">
              <span>{{ winners.t }}</span>
              <i class="t"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="game-table-bottom clearfix">
      <span class="info">
        <i class="fa fa-info-circle"></i> {{ $t('messages.limit', { limit: betLimit }) }} |
        <i class="fa fa-users"></i> {{ $t('messages.userOnline', { count: online }) }}
      </span>
      <a :href="route" class="btn btn-primary">{{ $t('messages.playNow') }}</a>
    </div>
  </div>
</template>
<script>
  import api from '../../../app/api'
  import Roadmap from '../../../app/lib/BaccaratRoadmap'
  const roadmap = new Roadmap()
  export default {
    name: 'game-baccarat',
    props: {
      user: {
        required: true,
        type: Object
      },
      kind: {
        required: true,
        type: String
      },
      tableId: {
        required: true,
        type: [Number, String]
      }
    },
    data () {
      return {
        config: {},
        stats: {},
        channels: {
          personal: null,
          baccarat: null,
          sessions: null
        },
        // members: {},
        statistics: {
          bigRoad: []
        },
        fixing: {
          col: 20,
          row: 6
        },
        maps: {
          bigRoad: [
            { key: 'BANKER', class: 'bb' },
            { key: 'PLAYER', class: 'bp' },
            { key: 'BANKER-BPAIR', class: 'bb-bp' },
            { key: 'BANKER-PPAIR', class: 'bb-pp' },
            { key: 'BANKER-PERFECTPAIR', class: 'bb-pf' },
            { key: 'PLAYER-BPAIR', class: 'bp-bp' },
            { key: 'PLAYER-PPAIR', class: 'bp-pp' },
            { key: 'PLAYER-PERFECTPAIR', class: 'bp-pf' }
          ]
        },
        renderings: {
          bigRoad: {}
        },
        betLimit: null
      }
    },
    mounted () {
      this.initialize()
    },
    methods: {
      initialize () {
        api.game.getGameConfigWithInformation(this.tableId,
          (response) => {
            this.config = response.data
            this.stats = _.get(response.data, 'info.detail.statistic', [])
          },
          (error) => {
            // Some api need to force user re-login, because jwt is not work.
            const status = _.get(error, 'response.status')
            if (status === 401) {
              location.href = '/logout'
              return
            }
          }
        )
      },
      getPointer (type, row, col) {
        const dot = this.statistics[type].find(v => v.column == col && v.row == row)
        if (!_.isUndefined(dot)) {
          this.renderings[type][dot.row + ':' + dot.column] = dot
          return true
        }
        return false
      },
      renderShortHand (type, row, col) {
        const func = type.charAt(0).toUpperCase() + type.slice(1);
        return this['render' + func](row, col)
      },
      renderBigRoad (row, col) {
        const dot = this.renderings['bigRoad'][row + ':' + col]
        if (Object.keys(dot.marker).length === 0) {
          return { class: 'empty' }
        }
        const tiesCount = _.get(dot, 'ties', 0)
        if (tiesCount > 0) {
          const marker = dot.marker
          const image = this.maps.bigRoad.find(v => v.key === marker)
          return {
            class: _.get(image, 'class') + '-t',
            count: tiesCount
          }
        } else {
          const exists = this.maps['bigRoad'].find((v) => v.key === _.get(dot, 'marker'))
          return {
            class: _.get(exists, 'class'),
            count: 0
          }
        }
      }
    },
    computed: {
      autoWidth () {
        const latest = _.maxBy(this.statistics.bigRoad, 'column')
        const max = _.get(latest, 'column')
        let width = 20 * (max + 1)
        width = width > 240 ? width : 240
        if (max > 10) {
          setTimeout(() => {
            // $(`#bc-${this.tableId} .game-table-preview`).scrollLeft(10000)
             $(`#bc-${this.tableId} .game-table-preview`).animate({
              scrollLeft: width
            }, 1000)
          }, 1000)
        }
        return width
      },
      online () {
        return _.get(this.config, 'info.online')
      },
      duration () {
        return _.get(this.config, 'game.bet_duration')
      },
      gameInfo () {
        const shoe = _.padStart(this.shoe, 4, 0)
        const round =  _.padStart(this.round, 3, 0)
        return `${shoe}-${round}`
      },
      shoe () {
        return _.get(this.config, 'info.detail.shoe')
      },
      round () {
        return _.get(this.config, 'info.detail.round')
      },
      winners () {
        const winner = _.get(this.config, 'info.detail.winners')
        return {
          p: _.get(winner, 'PLAYER', 0),
          b: _.get(winner, 'BANKER', 0),
          t: _.get(winner, 'TIE', 0)
        }
      },
      header () {
        const gameKey = _.get(this.config, 'table.game_key', 'baccarat')
        return this.$t(`games.${gameKey}`)
      },
      title () {
        return _.get(this.config, 'table.title')
      },
      route () {
        return '/games/live/baccarat/' + this.tableId
      },
      image () {
        return _.get(this.config, 'dealer.image')
      }
    },
    watch: {
      'user': {
        handler: function (value, old) {
          const game = _.get(value, 'config.games.baccarat.bet_limit.BANKER')
          this.betLimit = `${game.min}-${this.$options.filters.number(game.max)}`
        },
        deep: false
      },
      'stats': {
        handler: function (value, old) {
          this.statistics = roadmap.generateRoadmap(value, this.fixing.col, this.fixing.row, true)
        },
        deep: false
      }
    }
  }
</script>
<style scoped>
  i.empty {
    width: 19px;
    height: 19px;
    display: block;
    margin: 0;
  }
</style>




// WEBPACK FOOTER //
// resources/assets/js/admin/pages/games/Baccarat.vue